import type { Option } from "../entities";

/** Coarse times of day a `time` question may accept instead of an exact "HH:mm". */
export const TIME_PERIOD_OPTIONS: Option[] = [
  { id: "morning", text: { en: "Morning", ru: "Утро", de: "Morgens", fr: "Matin", es: "Mañana", tr: "Sabah", hi: "सुबह", sr: "Јутро" } },
  { id: "afternoon", text: { en: "Afternoon", ru: "День", de: "Nachmittags", fr: "Après-midi", es: "Tarde", tr: "Öğleden sonra", hi: "दोपहर", sr: "Поподне" } },
  { id: "evening", text: { en: "Evening", ru: "Вечер", de: "Abends", fr: "Soir", es: "Noche", tr: "Akşam", hi: "शाम", sr: "Вече" } },
  { id: "night", text: { en: "Night", ru: "Ночь", de: "Nachts", fr: "Nuit", es: "Madrugada", tr: "Gece", hi: "रात", sr: "Ноћ" } },
];

const PERIOD_IDS = new Set(TIME_PERIOD_OPTIONS.map((o) => o.id));

export function isTimePeriod(value: string): boolean {
  return PERIOD_IDS.has(value);
}

/** Maps an exact "HH:mm" onto a period: night 23:00–04:59, morning 05–11, afternoon 12–16, evening 17–22. */
export function periodOfTime(time: string): string {
  const hour = Number(time.slice(0, 2));
  if (hour >= 5 && hour < 12) return "morning";
  if (hour >= 12 && hour < 17) return "afternoon";
  if (hour >= 17 && hour < 23) return "evening";
  return "night";
}
